import { Either, left, right } from "fp-ts/lib/Either";
import UserEntity from "../../../../domain/entities/UserEntity";
import ErrorEntity, { ErrorEntityFromError } from "../../../../domain/entities/ErrorEntity";
import di from "../../../../DependencyInjection";
import HostApi, { HostApiName } from "../../../settings/HostApi";
import UserDto from "../../../dto/UserDto";
import KeyWordLocalization from "../../../../presentation/utils/KeyWordLocalization";

const CreateUserApiImpl = async (_: {
    user: UserEntity;
    password: string;
}): Promise<Either<ErrorEntity, UserEntity>> => {
    try {
        const relativeUrl = "/users";
        const body = UserDto.toJson(_.user);
        body.password = _.password;
        const response = await di.get<HostApi>(HostApiName).post(relativeUrl, body);
        const parsed: UserEntity = UserDto.fromJSON(response.data);
        return right(parsed);
    } catch (error: any) {
        if(error.code?.toString().includes("TheUsernameHasAlreadyBeenTaken")) {
            return left({code: "El nombre de usuario ya está en uso"});
        }
        return left({code: KeyWordLocalization.CreateUserPageCreateError});
    }
}

export default CreateUserApiImpl;